// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"349":"48404cf7","404":"c6f3b5b7","474":"67e479b9","648":"9b4ad391","703":"53371942","711":"18228932","807":"dcd21c69"}[chunkId] + ".chunk.js";
};